/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbAnneeReussieDto
 */
export interface FcbAnneeReussieDto {
    /**
     * 
     * @type {number}
     * @memberof FcbAnneeReussieDto
     */
    idanneeReussie?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbAnneeReussieDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbAnneeReussieDto
     */
    idanneeReussieGuid?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbAnneeReussieDto
     */
    actif?: boolean | null;
}

/**
 * Check if a given object implements the FcbAnneeReussieDto interface.
 */
export function instanceOfFcbAnneeReussieDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbAnneeReussieDtoFromJSON(json: any): FcbAnneeReussieDto {
    return FcbAnneeReussieDtoFromJSONTyped(json, false);
}

export function FcbAnneeReussieDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbAnneeReussieDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idanneeReussie': !exists(json, 'idanneeReussie') ? undefined : json['idanneeReussie'],
        'libelle': !exists(json, 'libelle') ? undefined : json['libelle'],
        'idanneeReussieGuid': !exists(json, 'idanneeReussieGuid') ? undefined : json['idanneeReussieGuid'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
    };
}

export function FcbAnneeReussieDtoToJSON(value?: FcbAnneeReussieDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idanneeReussie': value.idanneeReussie,
        'libelle': value.libelle,
        'idanneeReussieGuid': value.idanneeReussieGuid,
        'actif': value.actif,
    };
}

